import { endOfDay, format, isBefore, parseISO } from "date-fns";
import { formatISO } from "date-fns";

export const combineDates = (dateDate: Date, timeDate?: Date) => {
  return new Date(
    dateDate.getFullYear(),
    dateDate.getMonth(),
    dateDate.getDate(),
    timeDate ? timeDate.getHours() : 0,
    timeDate ? timeDate.getMinutes() : 0,
    timeDate ? timeDate.getSeconds() : 0
  );
};

export const isValidDate = (d: unknown): d is Date => {
  return d instanceof Date && !isNaN(d.getTime());
};

export const parseIsoDate = (d?: Date | string) => {
  if (!d) {
    return undefined;
  }

  const parsed = d instanceof Date ? d : parseISO(d);

  // Validate the parsed date
  return isValidDate(parsed) ? parsed : undefined;
};

export const formatDateToApi = (date: Date) => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
};

export const formatDateToApiUTC = (date: Date) => {
  return date.toISOString();
};

export const formatToIso = (localTime: Date, length?: number) => {
  const utcDate = new Date(
    localTime.getTime() + localTime.getTimezoneOffset() * 60000
  );

  return formatISO(utcDate).substring(0, length ?? 19);
};

export const padZeros = (time: number) => time.toString().padStart(2, "0");

const dateRangeRegex =
  /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})-(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})?/;

export const parseISODateRange = (str: string) => {
  const match = dateRangeRegex.exec(str);

  if (match) {
    const fromDate = match[1]; // "2023-11-30T23:00:00"
    const toDate = match[2] || null; // "2023-12-11T22:59:59" or null if it's not present

    return { fromDate, toDate };
  }

  return { fromDate: null, toDate: null };
};

export const validateToDate = (
  startDate: Date | undefined,
  endDate: Date | undefined
) => {
  if (!startDate || !endDate) {
    return true;
  }

  return isBefore(startDate, endOfDay(endDate));
};

export const validateToTime = (
  startDate: Date | undefined,
  startTime: Date | undefined,
  endDate: Date | undefined,
  endTime: Date | undefined
) => {
  if (!startDate || !endDate) {
    return true;
  }

  if (!startTime || !endTime) {
    return true;
  }

  return isBefore(
    combineDates(startDate, startTime),
    combineDates(endDate, endTime)
  );
};
